import ReactOnRails from 'react-on-rails';
import App from '../storefront/App';
ReactOnRails.register({ App });